const styles = theme => ({
  totalPrice: {
    marginBottom: [theme.spacing.unit * 3, '!important']
  },
  detailAttributeName: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: [theme.spacing.unit * 0.5, '!important']
  },
  expandMoreAttribute: {
    fontSize: 14,
    marginLeft: theme.spacing.unit * 0.25,
    position: 'relative',
    top: 2
  },
  tag: {
    fontWeight: 500,
    color: 'rgba(12,31,44,0.38)',
    padding: [[theme.spacing.unit * 0.25, theme.spacing.unit], '!important'],
    borderRadius: 12,
    backgroundColor: 'rgba(12,31,44,0.08)',
    marginLeft: [theme.spacing.unit, '!important'],
    display: 'block'
  },
  rootUnit: {
    marginTop: theme.spacing.unit * 1.5,
    padding: [[theme.spacing.unit * 2.25, theme.spacing.unit * 2]],
    width: '100%',
    backgroundColor: theme.palette.primary.light
  },
  unitExpandButton: {
    color: [theme.palette.primary.main, '!important'],
    fontSize: 18,
    top: -12
  },
  unitTitle: {
    fontWeight: [500, '!important'],
    color: [theme.palette.primary.main, '!important']
  },
  unitContainer: {
    marginRight: [theme.spacing.unit * 4, '!important'],
    color: [theme.palette.primary.main, '!important']
  },
  unitWeightInfo: {
    marginLeft: [theme.spacing.unit * 2, '!important'],
    color: [theme.palette.primary.main, '!important']
  },
  actionButton: {
    marginBottom: theme.spacing.unit * 2,
    width: '100%',
    '&:last-child': {
      marginBottom: 0
    }
  }
});

export default styles;
